import React, { useState, useEffect } from "react";
import "./Financials.css";
import * as FeatherIcon from "react-feather";
import MicroChart from "../../../HtmlElements/MicroChart";

export default function IncomeStatement({ records = [], requiredValue }) {
  if (!records || Object.keys(records).length === 0) {
    //  return <div></div>;
  }

  const income_statement = {
    IQ_REV: "Revenue",
    IQ_OTHER_REV: "Other Revenue",
    IQ_TOTAL_REV: "Total Revenue",
    IQ_COGS: "Cost of Goods Sold",
    IQ_GP: "Gross Profit",
    IQ_SGA: "Selling General & Admin Exp.",
    IQ_RD_EXP: "R&D Exp.",
    IQ_DA: "Depreciation & Amortization",
    IQ_OTHER_OPER: "Other Operating Expenses/(Income)",
    IQ_TOTAL_OTHER_OPER: "Other Operating Expenses, Total",
    IQ_OPER_INC: "Operating Income",
    IQ_INTEREST_EXP: "Interest Expense",
    IQ_INTEREST_INVEST_INC: "Interest and Invest. Income",
    IQ_NET_INTEREST_EXP: "Net Interest Expenses",
    IQ_OTHER_NON_OPER_EXP_SUPPL: "Other Non Operating Inc. (Exp.)",
    IQ_EBT_EXCL: "EBT Excl. Unusual Items",
    IQ_RESTRUCTURE: "Restructuring Charges",
    IQ_IMPAIRMENT_GW: "Impairment of Goodwill",
    IQ_OTHER_UNUSUAL: "Other Unusual Items",
    IQ_EBT: "EBT Incl. Unusual Items",
    IQ_INC_TAX: "Income Tax Expenses",
    IQ_EARNING_CO: "Earnings From Continuing Operations",
    IQ_DO: "Earnings of Discontinued Ops.",
    IQ_EXTRA_ACC_ITEMS: "Extraordinary Item & Account Change",
    IQ_NI_COMPANY: "Net Income to Company",
    IQ_MINORITY_INTEREST_IS: "Minority Int. in Earnings",
    IQ_NI: "Net Income",
    IQ_PREF_DIV_OTHER: "Pref. Dividends and Other Adj.",
    IQ_NI_AVAIL_INCL: "Net Income to Common Incl Extra Items",
    IQ_NI_AVAIL_EXCL: "Net Income to Common Excl Extra Items",
    IQ_BASIC_EPS_INCL: "Basic EPS",
    IQ_BASIC_EPS_EXCL: "Basic EPS Excl. Extra Items",
    IQ_BASIC_WEIGHT: "Weighted Avg. Basic Shares Out.",
    IQ_DILUT_EPS_INCL: "Diluted EPS",
    IQ_DILUT_EPS_EXCL: "Diluted EPS Excl. Extra Items",
    IQ_DILUT_WEIGHT: "Weighted Avg. Diluted Shares Out.",
    IQ_EPS_NORM: "Normalized Basic EPS",
    IQ_DILUT_EPS_NORM: "Normalized Diluted EPS",
    IQ_DIV_SHARE: "Dividends Per Share",
    IQ_PAYOUT_RATIO: "Payout Ratio %",
    IQ_EBITA: "EBITA",
    IQ_EBITDAR: "EBITDAR",
    IQ_TOTAL_REV_AS_REPORTED: "As Reported Total Revenue",
    IQ_EFFECTIVE_TAX_RATE: "Effective Tax Rate %",
    IQ_CURR_DOMESTIC_TAXES: "Current Domestic Taxes",
    IQ_CURR_FOREIGN_TAXES: "Current Foreign Taxes",
    IQ_CURR_TAXES: "Total Current Taxes",
    IQ_DEFERRED_DOMESTIC_TAXES: "Deferred Domestic Taxes",
    IQ_DEFERRED_FOREIGN_TAXES: "Deferred Foreign Taxes",
    IQ_DEFERRED_TAXES_TOTAL: "Total Deferred Taxes",
    IQ_NI_NORM: "Normalized Net Income",
    IQ_CAPITALIZED_INTEREST: "Interest Capitalized",
    IQ_INT_EXP_LTD: "Interest on Long Term Debt",
    IQ_NONCASH_PENSION_EXP: "Non-Cash Pension Expense",
    // "IQ_RESTATEMENT_IS" : "Restatment Type",
    // "IQ_CALC_TYPE_IS" : "Calculation Type",
    IQ_ADVERTISING: "Advertising Exp.",
    IQ_SALES_MARKETING: "Selling and Marketing Exp.",
    IQ_NET_RENTAL_EXP: "Net Rental Exp.",
    IQ_IMPUT_OPER_LEASE_INT_EXP: "Imputed Oper. Lease Interest Exp.",
    IQ_IMPUT_OPER_LEASE_DEPR: "Imputed Oper. Lease Depreciation",
    IQ_STOCK_BASED_SGA: "Stock-Based Comp, SG&A Exp.",
    IQ_STOCK_BASED_TOTAL: "Stock-Based Comp, Total",
    IQ_FILINGDATE_IS: "Filing Date",
  };

  const recordsArray = Array.isArray(records) ? records : [];
  const latestYears = Array.from(
    new Set(
      recordsArray.flatMap((record) => record.data.map((item) => item.year))
    )
  )
    .sort((a, b) => b - a)
    .slice(0, 5)
    .reverse();

  // NEW: Filter out year columns where every displayed row value is n.a. or 0
  const isValueEmpty = (value) =>
    value === "" || value === "Data Unavailable" || value === 0 || value === undefined || value === null;
  const visibleYears = latestYears.filter(year => {
    const fieldKeys = new Set(Object.keys(income_statement));
    const relevantRecords = recordsArray.filter(r => fieldKeys.has(r._id));
    return relevantRecords.some(record => {
      const item = record.data.find(d => d.year === year);
      return item !== undefined && !isValueEmpty(item.value);
    });
  });
  // OLD: const yearsToRender = latestYears;
  const yearsToRender = visibleYears;

  return (
    <>
      {
        <div className="col-md-12 mb-2 mt-2">
          <div className="custom_card_block">
            <div className="quarterly_result_block">
              <div className="head_top">
                <h5 className="main_head">Profit & Loss</h5>
                <p className="main_head_para">
                  Consolidated Figures in $Mn
                  {/* / <span className='blue_text'>View Standalone</span> */}
                </p>
              </div>
              <div className="quater_table_block">
                {latestYears.length <= 0 && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="alert alert-warning" role="alert">
                        Complete financials are only available in paid version.
                      </div>
                    </div>
                  </div>
                )}

                {latestYears.length > 0 && (
                  <div className="table-responsive custom_table_qut">
                    <table className="quater_table custom-resizable-table">
                      <thead className="quater_table_thead">
                        <tr className="quater_table_tr custom-resizable-table-header ">
                          {/* <th className="quater_table_th"></th>
                        <th className="quater_table_th">2019</th>
                        <th className="quater_table_th">2020</th>
                        <th className="quater_table_th">2021</th>
                        <th className="quater_table_th">2022</th>
                        <th className="quater_table_th">2023</th>
                        <th className="quater_table_th text-center" style={{width: '110px'}}>5-Year Trend</th> */}
                          <th className="quater_table_th"></th>
                          {/* OLD: {latestYears.map((year) => ( <th> ))} */}
                          {yearsToRender.map((year) => (
                            <th key={year} className="quater_table_th">
                             <div className="custom-resizable-table-th-content"> {year}</div>
                            </th>
                          ))}
                          <th
                            className="quater_table_th text-center"
                            style={{ width: "110px" }}
                          >
                           <div className="custom-resizable-table-th-content"> 5-Year Trend</div>
                          </th>
                        </tr>
                      </thead>

                      <tbody className="quater_table_tbody ">
                        {Object.entries(income_statement).map(
                          ([key, label]) => {
                            const record = records.find(
                              (item) => item._id === key
                            );
                            if (!record) return null;

                            const yearDataMap = Object.fromEntries(
                              record.data.map((item) => [item.year, item.value])
                            );
                            // OLD: const chartData = latestYears.map((year) => ({ category: year, value: parseFloat(yearDataMap[year] || 0) }));
                            const chartData = yearsToRender.map((year) => ({
                              category: year,
                              value: parseFloat(yearDataMap[year] || 0),
                            }));

                            return (
                              <tr className="quater_table_tr dimension-row cursor-pointer gtr-row " key={key}>
                                <td className="quater_table_td_left gtr-cell">
                                  <div className="gtr-cell-content-container">{label}</div>
                                </td>
                                {/* OLD: {latestYears.map((year) => ( <td> ))} */}
                                {yearsToRender.map((year) => (
                                  <td key={year} className="quater_table_td gtr-cell">
                                    <div className="gtr-cell-content-container">
                                    {yearDataMap[year] < 0 ? (
                                      <span style={{ color: "red" }}>
                                        {requiredValue(yearDataMap[year])}
                                      </span>
                                    ) : (
                                      requiredValue(yearDataMap[year])
                                    )}
                                    </div>
                                  </td>
                                ))}
                                <td className="quater_table_td text-center gtr-cell">
                                  <MicroChart
                                    data={chartData}
                                    chartType="bar"
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}
